import angular from 'angular';
import config from '../../ConfigModule/ConfigModule';
import MediaResource from '../../MediaModules/MediaResource';

export default angular.module('cms.media.select', [config, MediaResource])
    .component('selectMedia', {
        template: require('./select-media.html'),
        bindings: {
            model: '<',
            onRemoved: '&'
        },
        controller: function (CONFIG, MediaResource) {
            /** @ngInject */

            this.medias = {};

            this.$onInit = () => {
                MediaResource.get(
                    response => {
                        this.medias = response;
                    },
                    errResponse => {
                    }
                );
            }
        }
    })
    .name;



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/SelectMedia/SelectMedia.js